import React, { useState } from 'react'
import styled from 'styled-components'

// components
import DropDown from '../../../components/dropdown/DropDown'

// styles
import colors from '../../../styles/colors'

// images
import DownImg from '../../../assets/image/arrow/ic-down.svg'

function Search({
  settlementMonth,
  isEmpty,
  startDate,
  endDate,
  isInit,
  handleDropdown,
}) {
  return (
    <>
      <TitleText>정산주기</TitleText>
      <SearchWrapper>
        <DropdownSearch>
          {isEmpty || settlementMonth.length === 0 ? (
            <Empty>
              <span></span>
              <ArrowImg src={DownImg} />
            </Empty>
          ) : (
            <DropDown
              compareItem={
                !isInit ? settlementMonth[settlementMonth.length - 1] : endDate
              }
              isSettlement={true}
              isStart={true}
              defaultOption={settlementMonth[settlementMonth.length - 1]}
              options={settlementMonth}
              setOption={(opt) => handleDropdown(opt, 0)}
            />
          )}

          <TildeWrapper>~</TildeWrapper>

          {isEmpty || settlementMonth.length === 0 ? (
            <Empty>
              <span></span>
              <ArrowImg src={DownImg} />
            </Empty>
          ) : (
            <DropDown
              compareItem={!isInit ? settlementMonth[0] : startDate}
              isSettlement={true}
              defaultOption={settlementMonth[0]}
              options={settlementMonth}
              setOption={(opt) => handleDropdown(opt, 1)}
            />
          )}
        </DropdownSearch>
      </SearchWrapper>
    </>
  )
}

export default Search

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
    margin-bottom: 1px;
  }
`

const Empty = styled.div`
  width: 100%;
  height: 48px;
  border: solid 1px ${colors.G3};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;

  @media ${(props) => props.theme.mobile} {
    height: 36px;
  }
`

const ArrowImg = styled.img`
  width: 12px;
  height: 12px;
`

const DropdownSearch = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  button {
    width: 95%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    justify-content: space-between;
  }
`

const SubmitSearch = styled.div`
  span {
    display: flex;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background-color: ${colors.mainG};
    color: ${colors.W1};
    justify-content: center;
    align-items: center;
    cursor: pointer;

    h1 {
      display: none;

      @media ${(props) => props.theme.mobile} {
        display: flex;
        font-size: 16px;
        font-weight: 400;
      }
    }

    img {
      width: 19px;
      height: 19px;

      @media ${(props) => props.theme.mobile} {
        display: none;
      }
    }

    @media ${(props) => props.theme.mobile} {
      width: 100%;
      height: 40px;
      border-radius: 8px;
    }
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    margin-top: 16px;
  }
`

const TitleText = styled.span`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.BK};
  margin-bottom: 17px;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const TildeWrapper = styled.div`
  font-size: 20px;
  color: ${colors.BK};
  margin: 0 16px;

  @media ${(props) => props.theme.mobile} {
    font-size: 15px;
    margin: 0 9px;
  }
`
